import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class GuestIdentityVerificationActionModel extends Model {
  @attr('boolean') overridden!: boolean;

  @belongsTo('booking', {
    async: false,
    inverse: 'guestIdentityVerificationAction',
  })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'guest-identity-verification-action': GuestIdentityVerificationActionModel;
  }
}
